import Rate from '../../components/rate';
import { search } from '../../lib/api';
import { createDeployMessage } from '../../lib/deploy-messages';
import { calcProductImages } from '../../lib/images';
import { getProductsBySku } from '../../lib/product';

const RatePage = ({ preview, wines }) => (
  <Rate wines={wines} preview={preview} />
);

export default RatePage;

export async function getStaticProps() {
  let { results: deguSet } = await search(`filter=sku--980000000`);

  let wines = [];
  if (deguSet.length > 0 && deguSet[0]?.metadata?.weine) {
    wines = await getProductsBySku(
      deguSet[0].metadata.weine.split(','),
      'RatePage',
    );
    wines.filter((el) => el).forEach((wine) => calcProductImages(wine));
  } else {
    createDeployMessage({
      text: `RatePage: No package found for 980000000`,
      system: 'CMS',
      type: 'Error',
    });
  }

  return {
    props: {
      // filter null values
      wines: wines.filter((x) => x),
    },
  };
}
